import axiosAuth from '../../axiosMain';

async function index() {
  try {
    let response = await axiosAuth.get('/subcategories');
    return response.data.data;
  } catch (e) {}
}

export default {
  index,
};
